/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Rename_ValidationInputs */



/**
* | output |
* | --- |
* | "Name cannot be empty" |
*
* @param {Explorer_Info_Rename_ValidationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_rename_validation = /** @type {((inputs?: Explorer_Info_Rename_ValidationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Rename_ValidationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le nom ne peut pas etre vide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Name darf nicht leer sein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il nome non può essere vuoto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя не может быть пустым.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El nombre no puede estar vacío")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("名称不能为空")
	if (locale === "ja") return /** @type {LocalizedString} */ ("名前は空欄にできません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नाम खाली नहीं हो सकता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O nome não pode estar vazio.")
	return /** @type {LocalizedString} */ ("Name cannot be empty")
});